import Service, { service } from '@ember/service';
import * as AditoolsSite from '@ebiz/ember-aditools-site/utils/aditools-site';

export default class SiteService extends Service {
  @service intl;
  constructor() {
    super(...arguments);
    this.PartId = null;
  }
  // Provide the part ID via the with-part route.
  setPartId(value) {
    this.PartId = value;
  }

  // Build 99% of everything from the siteconfig service results.
  start(/*url, rootUrl, defaultLocale, supportedlocales, logger, fastboot*/) {
    return AditoolsSite.start(this, ...arguments).then(() => {
      this.intl.setLocale(this.FullLocale);
      return this;
    });
  }
}
